<div class="time-selector  d-flex justify-content-end" [ngClass]="{'disabled':disabled}">
    <div class="input-group" [ngClass]="{'hasZoomButtons': zoomButtons,'hasSearchButton': searchButton, 'hasLabel': label != null}">
        <div class="input-group-prepend" *ngIf="label != null">
            <span class="input-group-text">
                <span>{{label}}</span>
            </span>
        </div>
        <div class="input-group-prepend" *ngIf="zoomButtons">
            <a class="input-group-text btn  px-2" (click)=" submitForm(false,true)">
                <i class="mio">remove</i>
            </a>
        </div>
        <ng-container *ngIf="!disabled">
            <div class="btn-group " #timeSelectorElement>
                <a class="btn btn-white px-3 d-flex justify-content-between align-items-center text-wrap"
                    [ngbPopover]="daterangePopover" popoverClass="daterangePopoverMain" [autoClose]="'outside'" [placement]="placement"
                    [container]="'body'" #popover="ngbPopover"><span class="text-wrap pr-2">{{parsedTimeLabel != null ? parsedTimeLabel : 'Loading...'}}</span><i
                        class="mio button-icon">calendar_today</i> </a>

            </div>
        </ng-container>
        <ng-container *ngIf="disabled">
            <div class="btn-group">
                <a class="btn btn-white px-3  d-flex justify-content-between align-items-center text-wrap"
                    style="box-shadow: unset !important;" ><span
                        class="text-wrap pr-2">{{parsedTimeLabel}}</span><i class="mio button-icon">calendar_today</i>
                </a>
            </div>
        </ng-container>
        <div class="input-group-append" *ngIf="zoomButtons">
            <a class="input-group-text btn  px-2" (click)=" submitForm(true,false)">
                <i class="mio">add</i>
            </a>
        </div>
        <div class="input-group-append" *ngIf="searchButton && !disabled">
            <a class="input-group-text btn  px-2" (click)=" submitForm()">
                <i class="mio">search</i>
            </a>
        </div>
        <div class="input-group-append" *ngIf="searchButton && disabled">
            <a class="input-group-text btn  px-2">
                <i class="mio">search</i>
            </a>
        </div>
    </div>

</div>

<ng-template #daterangePopover >
    <div class="row time-selector" [ngClass]="{'daterangePopover': !rangeDisabled, 'datePopover': rangeDisabled }">
        <div class="border-right" [ngClass]="{'col-md-8': (!hideRelativeRanges && !rangeDisabled), 'col-md-12' : rangeDisabled}">
            <div class="row">
                <div class="col-md-12 pr-0">
                    <!-- (navigate)="date = $event.next" -->
                    <!-- (select)="date = $event.next; onDateSelection($event)"  -->
                    <ngb-datepicker #dp (dateSelect)="onDateSelection($event)" [navigation]="'select'" [displayMonths]="!rangeDisabled ? 2 : 1"
                        [dayTemplate]="t" [outsideDays]="'visible'">
                    </ngb-datepicker>
                </div>
                <div class="col-md-6" [ngClass]="{'col-md-12': rangeDisabled}">
                    <ngb-timepicker [ngModel]="fromTime" (ngModelChange)="updateFromTime($event, fromDate)" size="small"
                        [seconds]="true"></ngb-timepicker>

                </div>
                <div class="col-md-6" *ngIf="!rangeDisabled">
                    <ngb-timepicker [ngModel]="toTime" (ngModelChange)="updateToTime($event, toDate)" size="small" 
                        [seconds]="true"></ngb-timepicker>
                </div>
            </div>
        </div>
        <div class="col-md-4" *ngIf="!hideRelativeRanges && !rangeDisabled">
            <div class="row" *ngIf="widgetDefaultsActive">
                <div class="col-md-12 text-center btn-group pt-2 pr-3">
                    <button class="btn btn-sm btn-light" [ngClass]="{'active' : content == null}"
                        (click)="useWidgetDefault()">
                        Use widget default</button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6" >
                    <div class="list-group">
                        <span class="list-group-item d-flex"><strong>Relative</strong></span>
                        <a class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                            *ngFor="let interval of dateRangeIntervals.intervals"
                            [ngClass]="{'active' : content != null && interval.label == content.label}"
                            (click)="selectInterval(interval)">{{interval.label}}</a>
                    </div>
                </div>
                <div class="col-md-6" >
                    <div class="list-group">
                        <span class="list-group-item d-flex"><strong>Absolute</strong></span>
                        <a class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                            *ngFor="let interval of absoluteDateRangeIntervals.intervals"
                            [ngClass]="{'active' : content != null && interval.label == content.label}"
                            (click)="selectInterval(interval)">{{interval.label}}</a>
                        <span class="list-group-item d-flex"><strong>Custom</strong></span>
                        <a class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                            [ngClass]="{'active' : content != null && content.label == null}"
                            (click)="content.label = null">Custom
                            range</a>
                    </div>
                </div>
            </div>

        </div>

    </div>
    <div class="row" *ngIf="!rangeDisabled">
        <div class="col-lg-8 pl-3 py-2 text-muted" *ngIf="selectedTimeRange != null">
            <small>
                <strong>From:</strong>
                {{selectedTimeRange.start | date: user.options['dateFormat'] : user.options['timeZone'] != 'Client default' ? user.options['timeZone'] : ''  }}
                - <strong>To:</strong>
                {{selectedTimeRange.end | date: user.options['dateFormat'] : user.options['timeZone'] != 'Client default' ? user.options['timeZone'] : ''  }}
            </small>
        </div>
        <div class="col-lg-8 pl-3 py-2 text-muted" *ngIf="selectedTimeRange == null">
            Each widget will use its own timerange.
        </div>
        <div class="col-lg-4 text-right">
            <button class="btn btn-primary shadow-small btn-sm pull-right mr-2 mb-2"
                (click)="submitForm(); popover.close()">Apply</button>
        </div>
    </div>
    <div class="row" *ngIf="rangeDisabled">
        <div class="col-lg-12 text-right px-2">
            <button class="btn btn-primary shadow-small btn-sm pull-right mr-2 mb-2"
                (click)="submitForm(); popover.close()">Apply</button>
        </div>
    </div>

    <ng-template #t let-date let-focused="focused" let-currentMonth="currentMonth">
        <span class="daterange-day" [class.focused]="focused" [class.range]="isRange(date)"
            [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
            (mouseleave)="hoveredDate = null" [class.notCurrentMonth]="date.month !== currentMonth">
            {{ date.day }}
        </span>
    </ng-template>
</ng-template>
